<template>
  <div class="color-for-text-content" id="identidade-visual-cores-cores-para-textos" data-search-anchor>
    <div class="color-for-text-title-wrapper">
      <h1 class="color-for-text-title-span">{{ colorWhatNotToDoTitleSpan }}</h1>
      <h1 class="color-for-text-title">{{ colorWhatNotToDoTitle }}</h1>
    </div>
    <div class="description-color-for-text-icons-wrapper">
      <div class="color-for-text-icon-wrapper">
        <IconCheck />
        <p class="color-for-text-description">{{ colorWhatNotToDoDescription }}</p>
      </div>
      <div class="color-for-text-icon-wrapper">
        <IconCancel />
        <p class="color-for-text-description">{{ colorWhatNotToDoDescription2 }}</p>
      </div>
    </div>
    <div class="color-for-text-card-item" :style="{ backgroundImage: `url(${ImageSrc})` }"></div>
  </div>
</template>

<script lang="ts">
import IconCancel from '@/assets/icons/IconCancel.vue'
import IconCheck from '@/assets/icons/IconCheck.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import ColorPageMixin from '@/mixins/color-page-mixin'
import { ColorPageStore } from '@/store/visual-identity-page/color-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({ components: { IconCancel, IconCheck } })
export default class ColorsForTextSection extends Mixins(ColorPageMixin) {
  colorPageStore: PageStoreContract = getModule(ColorPageStore, this.$store)

  get colorWhatNotToDoTitleSpan(): string {
    return this.getElementTitle(5, 0)
  }

  get colorWhatNotToDoTitle(): string {
    return this.getElementText(5, 0)
  }

  get colorWhatNotToDoDescription(): string {
    return this.getElementText(5, 1)
  }

  get colorWhatNotToDoDescription2(): string {
    return this.getElementText(5, 2)
  }

  get ImageSrc(): string {
    return this.getElementMedia(5, 3)
  }

  async getColorPage(): Promise<void> {
    await this.colorPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.colorPageStore.isLoading) {
      await this.getColorPage()
    }
  }
}
</script>

<style lang="scss">
.color-for-text-content {
  display: grid;
  max-width: 1032px;
  width: 100%;
}

.color-for-text-title-wrapper {
  display: flex;
  align-items: center;
  height: 6vh;
  padding-top: 6.25rem;
  padding-bottom: 1rem;
}

.color-for-text-title-span {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  margin-right: 5px;
  color: #b3b3b3;
}

.color-for-text-title {
  font-size: 30px;
  font-weight: 700;
  line-height: 57px;
  letter-spacing: -0.01em;
  text-align: left;
  color: #000000;
}

.description-color-for-text-icons-wrapper {
  position: relative;
  display: grid;
  grid-template-columns: 51.5% 48.5%;  
}

.color-for-text-description {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: left;
  padding-left: 7px;
  width: 378px; 
}

.color-for-text-icon-wrapper {
  display: flex;
  align-items: center;  
}

.color-for-text-card-item {
  position: relative;
  left: 0;
  max-width: 1032px;
  width: 100%;
  height: 705px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
</style>
